import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Select } from "antd";
import Linechart from "../../../components/dashboard/linechart";
import TaskCard from "../../../components/cards/taskCard";
import { useTranslation } from "react-i18next";

const EvidenceDetails = () => {
  const { t } = useTranslation();
  const { Option } = Select;

  const months = ["January", "March", "May", "July", "August", "October", "November"];
  const taskcardData = [
    {
      heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
      date: "October 5, 2024 - 2:00 PM ",
    },
    {
      heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
      date: "October 5, 2024 - 2:00 PM ",
    },
    {
      heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
      date: "October 5, 2024 - 2:00 PM ",
    },
    {
      heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
      date: "October 5, 2024 - 2:00 PM ",
    },
    {
      heading: "Lorem ipsum dolor sit amet consectetur. Dui tellus quis morbi diam.",
      date: "October 5, 2024 - 2:00 PM ",
    },
  ];
  const contractInfo = [
    { label: t("dashboard.evidenceManagement.caseID"), value: "C001" },
    { label: t("dashboard.evidenceManagement.documentName"), value: "John Doe" },
    { label: t("dashboard.evidenceManagement.evidenceType"), value: "Jane Smith" },
    { label: t("dashboard.evidenceManagement.dateSubmitted"), value: "Mike Johnson" },
    { label: t("dashboard.evidenceManagement.witness"), value: "May 12, 2024" },
    { label: t("dashboard.evidenceManagement.description"), value: "John Smith (Witness)" },
    { label: t("dashboard.evidenceManagement.clientInfo"), value: "John Doe" },
  ];

  return (
    <>
      <div className="dashboard-main flex flex-col gap-[31px] ">
        <div className="top flex gap-[20px] sm-s:flex-col">
          <div className="cases-div  max-w-[25%] max-sm:max-w-[100%] w-full flex flex-col  pt-[18px] pb-[21px] px-[25px] gap-[24px] rounded-[20px] bg-[#F4F4F4]  shadow-lg">
            <div className="flex justify-between w-100 items-center">
              <h5 className="small font-bold text-blue">Details</h5>
              <p className="e-small bg-[#E0EAF1] font-medium font-poppins text-[#2183C6] rounded-[54px] px-4 py-[6px]">
                Case In Progress
              </p>
            </div>
            <div className="flex flex-col gap-[15px]">
              {contractInfo.map(({ label, value }, index) => (
                <div key={index} className="flex items-center justify-between gap-[15px]">
                  <p className="text-darkGrey font-semibold medium">{label}</p>
                  <p className="text-darkGrey font-semibold medium text-right">{value}</p>
                </div>
              ))}
            </div>
          </div>
          <div class="reminder-div  flex flex-col gap-[25px] max-w-[75%] max-sm:max-w-[100%] w-full pt-[23px] max-sm:px-[20px] px-[33px] rounded-[20px] border-[1.299px] border-[rgba(255,255,255,0.28)] bg-[#F4F4F4] shadow-lg">
            <h5 className="small font-bold text-blue">Upcoming Tasks</h5>
            <div className="reminder-card-wrapper bg-transparent flex flex-col gap-[7px] max-sm:pr-[10px] pr-[22px] max-h-[322px] overflow-y-auto">
              <TaskCard taskcardData={taskcardData} />
            </div>
          </div>
        </div>
        <div className="bottom flex flex-col gap-[43px] drop-shadow-md rounded-[21px] max-sm:px-[20px] px-[50px] py-[15px] border-[rgba(255,255,255,0.28)] bg-[#F4F4F4] shadow-lg">
          <div className="performance flex justify-between items-center">
            <p className="text-blue font-semibold large">Activity Overview</p>
            <Select placeholder="Year" style={{ width: 108 }} className="graph-dropdown">
              {months.map((month, index) => (
                <Option key={index} value={month}>
                  {month}
                </Option>
              ))}
            </Select>
          </div>
          <Linechart />
        </div>
      </div>
    </>
  );
};

export default EvidenceDetails;
